import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "resultCount", "filterStatus"]
  
  connect() {
    this.filters = {
      mobileConnected: 'all',
      assignmentClick: 'all'
    }
  }
  
  toggleMobileFilter(event) {
    this.toggleFilter('mobileConnected', event.currentTarget)
  }
  
  toggleClickFilter(event) {
    this.toggleFilter('assignmentClick', event.currentTarget)
  }
  
  toggleFilter(filterType, headerElement) {
    if (this.filters[filterType] === 'all') {
      this.filters[filterType] = 'false'
    } else if (this.filters[filterType] === 'false') {
      this.filters[filterType] = 'true'
    } else {
      this.filters[filterType] = 'all'
    }
    
    this.applyFilters()
    this.updateHeaderUI(filterType, headerElement)
  }
  
  applyFilters() {
    let visibleCount = 0
    
    this.rowTargets.forEach(row => {
      const mobileConnected = row.dataset.mobileConnected
      const assignmentClick = row.dataset.assignmentClick
      
      let showRow = true
      
      // Check mobile connected filter
      if (this.filters.mobileConnected !== 'all') {
        const matchesMobile = (this.filters.mobileConnected === 'false' && mobileConnected === 'false') ||
                             (this.filters.mobileConnected === 'true' && mobileConnected === 'true')
        if (!matchesMobile) showRow = false
      }
      
      // Check assignment click filter
      if (this.filters.assignmentClick !== 'all') {
        const matchesClick = (this.filters.assignmentClick === 'false' && assignmentClick === 'false') ||
                            (this.filters.assignmentClick === 'true' && assignmentClick === 'true')
        if (!matchesClick) showRow = false
      }
      
      row.style.display = showRow ? '' : 'none'
      if (showRow) visibleCount++
    })
    
    this.updateResultCount(visibleCount)
  }
  
  updateHeaderUI(filterType, headerElement) {
    const indicator = headerElement.querySelector('.filter-indicator')
    const state = this.filters[filterType]
    
    if (state === 'false') {
      indicator.textContent = '▼'
      headerElement.style.color = '#dc3545'
    } else if (state === 'true') {
      indicator.textContent = '▲'
      headerElement.style.color = '#28a745'
    } else {
      indicator.textContent = ''
      headerElement.style.color = ''
    }
  }
  
  updateResultCount(visibleCount) {
    this.resultCountTarget.textContent = visibleCount
    
    const activeFilters = []
    if (this.filters.mobileConnected === 'false') activeFilters.push('not connected')
    if (this.filters.mobileConnected === 'true') activeFilters.push('connected')
    if (this.filters.assignmentClick === 'false') activeFilters.push('not clicked')
    if (this.filters.assignmentClick === 'true') activeFilters.push('clicked')
    
    if (activeFilters.length > 0) {
      this.filterStatusTarget.textContent = `(showing ${activeFilters.join(', ')})`
    } else {
      this.filterStatusTarget.textContent = ''
    }
  }
}